<!-- ReviewDraftAgentRenewLicense -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
                col-12
                d-none d-lg-flex
                justify-content-between
                align-items-center
              ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
              col-left-menu
              d-flex d-lg-none
              border-bottom
              align-items-center
              border-bottom
              w-100
              ps-3
              pe-3
            " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="2" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <div class="container py-3 font-family-bla">
                    <!-- แถบแจ้งเตือน -->
                    <div class="notice-bar mb-3">
                        โปรดตรวจสอบความถูกต้องของข้อมูลในเอกสารสัญญาตัวแทนให้ครบถ้วน ก่อนดำเนินการต่อ
                    </div>

                    <!-- รายการเอกสาร -->
                    <div class="card-wrap p-3">
                        <div v-for="doc in visibleDocs" :key="doc.key"
                            class="doc-row d-flex justify-content-between align-items-center">
                            <div class="doc-title">
                                {{ doc.title }}
                                <font-awesome-icon v-if="doc.viewed" :icon="faCheckCircle" class="text-success ms-2" />
                            </div>
                            <button class="btn btn-outline-primary" @click="previewDoc(doc)">
                                <font-awesome-icon :icon="faFileLines" />
                            </button>

                        </div>
                    </div>

                    <!-- ปุ่ม -->
                    <div class="d-flex align-items-center justify-content-between mt-4">
                        <button class="btn btn-secondary btn-confirm" @click="goBack">ย้อนกลับ</button>
                        <div class="flex-grow-1"></div>
                        <button class="btn btn-bla btn-confirm" :disabled="!canRequestOtp" @click="requestOtp">
                            ขอรับ OTP
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark, faFileLines, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "./StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: 'ReviewDraftAgentRenewLicense',
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            faFileLines: faFileLines,
            faCheckCircle: faCheckCircle,
            Loading: true,
            // ใช้ data ล้วน ๆ
            isRegisUnitLink: false, // true = แสดงรายการ Unit Linked เพิ่ม
            isRenewAgentRegis: false,
            docs: [],
        }
    },
    computed: {
        visibleDocs() {
            // กรองให้เหลือเฉพาะรายการที่ต้องแสดง
            return this.docs.filter(d => !d.showWhenUnitLinked || (this.isRegisUnitLink && this.isRenewAgentRegis) )
        },
        canRequestOtp() {
            // ต้องเปิดดูทุกอันที่แสดงก่อนถึงจะกดได้
            return this.visibleDocs.every(d => d.viewed)
        }
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    methods: {
        BindingData() {
            this.isRegisUnitLink = this.$store.state.AgentRenewLicense.preview.isRegisUnitLink;
            this.isRenewAgentRegis = this.$store.state.AgentRenewLicense.preview.isRenewAgentRegis;
            this.docs = [
                {
                    key: 'life',
                    title: 'ร่างใบคำขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต',
                    url: 'AgencyERequest/GenerateFileReportTc7Certification', // ใส่ลิงก์จริงได้
                    viewed: false
                },
                {
                    key: 'unit',
                    title: 'ร่างใบคำขอต่ออายุการขึ้นทะเบียนตัวแทนประกันชีวิตควบการลงทุน',
                    url: 'AgencyERequest/GenerateFileReportAgentRenewLicenseUL',
                    viewed: false,
                    showWhenUnitLinked: true
                }];
        },
        goBack() {
            this.$router?.replace('UploadFileAgentRenewLicense');
        },
        async previewDoc(doc) {
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");

            this.Loading = true;

            let response;

            const formData = new FormData();
            formData.append("Photo", this.$store.state.AgentRenewLicense.uploadfile.files.photo);// รูปถ่ายหน้าตรงใช้ติดบัตร,

            if (doc.key === "life") {
                response = await fetch(process.env.VUE_APP_URL_IIS_API + doc.url, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${AuthorizeToken}`
                    },
                    body: formData
                });
            } else {
                response = await fetch(process.env.VUE_APP_URL_IIS_API + doc.url, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${AuthorizeToken}`
                    }
                });
            }

            // แปลงเป็น blob เหมือนเดิม
            const blob = await response.blob();

            // สร้าง URL ชั่วคราว
            const blobUrl = URL.createObjectURL(blob);

            // เปิดในแท็บใหม่
            window.open(blobUrl, "_blank");

            this.Loading = false;

            // revoke ทีหลัง 500_000=5 นาที
            setTimeout(() => URL.revokeObjectURL(blobUrl), 500_000);

            // ทำเครื่องหมายว่าเปิดดูแล้ว
            doc.viewed = true;
        },
        async requestOtp() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }

            this.Loading = true;

            // Call API SendOTP
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/AgentRenewLicenseSendOTP`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                this.Loading = false;

                if (response.status === 200) {
                    this.$store.state.AgentRenewLicense.verifyOTP.phoneNumber = response.data.phoneNumber;
                    this.$store.state.AgentRenewLicense.verifyOTP.reference = response.data.reference;
                    this.$store.state.AgentRenewLicense.verifyOTP.expireDate = response.data.expireDate;

                    this.$router?.replace?.('/OTPVerifyAgentRenewLicense');// ขอรหัส OTP
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla'// pv-btn-primary
                        }
                    });
                    return;
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla'// pv-btn-primary
                    }
                });
                return;
            });
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    }
}
</script>

<style scoped>
/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

/* แถบแจ้งเตือน */
.notice-bar {
    background: #FFF36B;
    border: 2px solid #F9E24A;
    border-radius: 8px;
    padding: .6rem .9rem;
    text-align: center;
    font-weight: 600;
}

/* กล่องหลัก */
.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 12px;
    background: #fff;
}

/* แถวเอกสาร */
.doc-row {
    border: 1px solid #e9ecef;
    border-radius: 10px;
    padding: .9rem 1rem;
    margin-bottom: .75rem;
}

.doc-title {
    font-size: 1.05rem;
}

/* ปุ่มไอคอน */
.btn-icon {
    min-width: 130px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* ปุ่มทรง pill */
.btn-pill {
    border-radius: 999px;
    padding: .6rem 1.6rem;
    min-width: 140px;
}

/* พรีวิวใน Swal */
.swal-wide {
    max-width: 95vw !important;
}

.swal-font {
    font-family: "DB Heavent", sans-serif;
}

.preview-box {
    width: 100%;
    height: 70vh;
}

.preview-box iframe {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: #f8f9fa;
}

/* ตอบสนองจอเล็ก */
@media (max-width: 576px) {
    .btn-icon {
        min-width: auto;
    }

    .preview-box {
        height: 62vh;
    }
}
</style>
